const TOKEN_KEY = "token";

export function getSessionToken() {
  const sessionToken = sessionStorage.getItem(TOKEN_KEY);
  if (sessionToken) return sessionToken;
  const legacyToken = localStorage.getItem(TOKEN_KEY);
  if (legacyToken) {
    sessionStorage.setItem(TOKEN_KEY, legacyToken);
    localStorage.removeItem(TOKEN_KEY);
    return legacyToken;
  }
  return "";
}

export function setSessionToken(token) {
  const value = String(token || "").trim();
  if (!value) return;
  sessionStorage.setItem(TOKEN_KEY, value);
  localStorage.removeItem(TOKEN_KEY);
}

export function clearSessionToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

export function hasSessionToken() {
  return Boolean(getSessionToken());
}
